const breakpoints = {
  values: {
    xs: 0,
    sm: 440,
    md: 768,
    lg: 1024,
    xl: 1440,
    xxl: 1536,
  },
};

export default breakpoints;
